/* Product page clean layout (sections/product.liquid, "Clean layout" setting).
   1. Left thumbnails: show only as many whole thumbs as fit beside the main image (5 at most,
      Tristan 12 Oct 2026), with up/down arrows that page through the rest (greyed out at either end).
   2. Shop Pay line under Add to cart: keep "4 payments of $X" in step with the variant.
   3. Phones: a thin progress bar under the "Recently viewed" and "You might also like" sliders.
   4. Phones: the Description tab shows its first five sentences and an italic "(read more)"
      (Tristan 15 Oct 2026). Desktop always shows the whole description (CSS). */
(function () {
  function initThumbs(root) {
    var thumbs = root.querySelector('.product__thumbs');
    var holder = thumbs && thumbs.querySelector('[data-thumbs-slider]');
    var more = thumbs && thumbs.querySelector('[data-thumbs-more]');
    var prev = thumbs && thumbs.querySelector('[data-thumbs-prev]');
    var slides = root.querySelector('.product__slides');
    if (!holder || !more || !slides) return;

    var desktop = window.matchMedia('(min-width: 750px)');
    var MAX_THUMBS = 5;
    var step = 0;

    function setArrows(on) {
      more.hidden = !on;
      if (prev) prev.hidden = !on;
      thumbs.classList.toggle('has-more', on);
    }

    function fit() {
      holder.style.height = '';
      setArrows(false);
      if (!desktop.matches) return;

      var items = holder.querySelectorAll('[data-thumb-item]');
      if (items.length < 2) return;
      var gap = items[1].offsetTop - items[0].offsetTop - items[0].offsetHeight;
      step = items[0].offsetHeight + gap;
      if (!step) return;

      // Room for the arrows above and below the thumbs
      var arrow = parseFloat(getComputedStyle(thumbs).getPropertyValue('--thumbs-arrow')) || 28;
      var room = slides.offsetHeight - arrow * (prev ? 2 : 1);
      var count = Math.min(MAX_THUMBS, Math.max(1, Math.floor((room + gap) / step)));
      if (count >= items.length) return;

      holder.style.height = count * step - gap + 'px';
      thumbs.style.setProperty('--thumbs-height', holder.style.height);
      setArrows(true);
      update();
    }

    function atStart() {
      return holder.scrollTop <= 2;
    }

    function atEnd() {
      return holder.scrollTop + holder.clientHeight >= holder.scrollHeight - 2;
    }

    function update() {
      more.disabled = atEnd();
      if (prev) prev.disabled = atStart();
    }

    // Page by whole thumbs so the next set lines up with the top
    function page(dir) {
      var rows = Math.max(1, Math.floor(holder.clientHeight / step));
      var target = Math.max(0, Math.round(holder.scrollTop / step + dir * rows) * step);
      holder.scrollTo({ top: target, behavior: 'smooth' });
    }

    more.addEventListener('click', function () { page(1); });
    if (prev) prev.addEventListener('click', function () { page(-1); });

    holder.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { fit(); }).observe(slides);
    }
    desktop.addEventListener('change', fit);
    window.addEventListener('load', fit);
    fit();
  }

  function initInstallments(root) {
    var amount = root.querySelector('[data-installments] [data-installment-amount]');
    if (!amount) return;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var format = function (cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
    };
    var native = root.querySelector('[data-installments-native]');
    var copy = native && native.querySelector('[data-installments-copy]');
    var terms = native && native.querySelector('shopify-payment-terms');
    var fourPayments = function () { return '4 payments of <span data-installment-amount>' + amount.textContent + '</span> at 0% APR'; };

    // "From $X/mo or 0% APR" with the monthly figure from Shopify's own (hidden) banner, else Pay in 4.
    var syncCopy = function () {
      if (!copy) return;
      var text = terms && terms.shadowRoot ? terms.shadowRoot.textContent : '';
      var match = text.match(/from\s*([^\s\/]*\d[\d.,]*)\s*\/\s*mo/i);
      var html = match ? 'From <strong>' + match[1] + '</strong>/mo or 0% APR' : fourPayments();
      if (copy.innerHTML !== html) copy.innerHTML = html;
    };
    if (terms) {
      var watch = function () {
        if (!terms.shadowRoot) return false;
        new MutationObserver(syncCopy).observe(terms.shadowRoot, { childList: true, subtree: true, characterData: true });
        syncCopy();
        return true;
      };
      if (!watch()) {
        var tries = 0;
        var timer = setInterval(function () { if (watch() || ++tries > 40) clearInterval(timer); }, 250);
      }
    }

    root.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || typeof variant.price !== 'number') return;
      amount.textContent = format(variant.price / 4);
      if (terms && variant.id) terms.setAttribute('variant-id', variant.id);
      if (copy && !/\/mo/.test(copy.textContent)) copy.innerHTML = fourPayments();
      amount = root.querySelector('[data-installments] [data-installment-amount]') || amount;
    });
  }

  // The bar's thumb is as wide as the visible share of the row and follows the scroll.
  // Hidden when everything fits (or on desktop, by CSS).
  function initProgress(track) {
    if (track.dataset.progress) return;
    track.dataset.progress = 'true';
    var bar = document.createElement('div');
    bar.className = 'slider-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span class="slider-progress__bar"></span>';
    var anchor = track.closest('grid-slider') || track;
    anchor.parentNode.insertBefore(bar, anchor.nextSibling);
    var thumb = bar.firstChild;
    var queued = false;

    function update() {
      queued = false;
      var width = track.scrollWidth;
      var visible = track.clientWidth;
      bar.hidden = !visible || width <= visible + 2;
      if (bar.hidden) return;
      var share = visible / width;
      var at = track.scrollLeft / Math.max(1, width - visible);
      thumb.style.width = share * 100 + '%';
      thumb.style.transform = 'translateX(' + Math.min(1, Math.max(0, at)) * (1 / share - 1) * 100 + '%)';
    }
    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    // Recently viewed fills in after the page loads
    new MutationObserver(queue).observe(track, { childList: true });
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(track);
    update();
  }

  var READ_MORE_SENTENCES = 5;

  // Where the Nth sentence ends inside el: {node, offset} or null if the text is shorter.
  function sentenceEnd(el, n) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var count = 0;
    var node;
    while ((node = walker.nextNode())) {
      var re = /[.!?]+["'\u201d\u2019)]*(?=\s|$)/g;
      var m;
      while ((m = re.exec(node.data))) {
        count += 1;
        if (count === n) return { node: node, offset: m.index + m[0].length };
      }
    }
    return null;
  }

  function initReadMore(root) {
    var first = root.querySelector('.product-tabs .tab-link-0');
    var entry = root.querySelector('.product-tabs .tab-content-0 .tab-content__entry');
    if (!first || !entry || !/^\s*description\s*$/i.test(first.textContent)) return;
    if (entry.parentNode.querySelector('.desc-preview')) return;

    var end = sentenceEnd(entry, READ_MORE_SENTENCES);
    if (!end) return;
    var rest = document.createRange();
    rest.setStart(end.node, end.offset);
    rest.setEndAfter(entry.lastChild);
    if (rest.toString().replace(/\s+/g, '').length < 20) return; // nothing worth hiding

    var head = document.createRange();
    head.setStartBefore(entry.firstChild);
    head.setEnd(end.node, end.offset);

    var preview = document.createElement('div');
    preview.className = 'desc-preview';
    preview.appendChild(head.cloneContents());
    // The link goes at the end of the last block that has text, so it reads as part of the copy
    var blocks = preview.querySelectorAll('p, li, div, span');
    var target = preview;
    for (var i = blocks.length - 1; i >= 0; i--) {
      if (blocks[i].textContent.trim()) { target = blocks[i]; break; }
    }
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'desc-readmore';
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = '<em>(read more)</em>';
    target.appendChild(document.createTextNode(' '));
    target.appendChild(button);
    button.addEventListener('click', function () {
      entry.parentNode.classList.add('is-expanded');
      button.setAttribute('aria-expanded', 'true');
    });
    entry.parentNode.insertBefore(preview, entry);
    entry.parentNode.classList.add('has-readmore');
  }

  function init() {
    document.querySelectorAll('.product--clean, .product--clean-buttons').forEach(function (root) {
      initThumbs(root);
      initInstallments(root);
      initReadMore(root);
    });
    document.querySelectorAll('.template-product .recent__content.grid--mobile-slider, .template-product .Featuredcollection .grid--mobile-slider').forEach(initProgress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
